<template>
    <el-link class="phoneCard" :icon="realPhone ? '' : 'el-icon-view'" @click="getRealPhone">
        {{ displayPhone }}
    </el-link>
</template>

<script>
export default {
    name:'phoneCard',
    props:{
        phone:'',
        id:''
    },
    data(){
        return{
            realPhone:''
        }
    },
    watch:{
        'id'(){
            this.realPhone = ''
        }
    },
    computed:{
        displayPhone(){
            return this.realPhone || this.phone
        }
    },
    methods:{
        getRealPhone(){
            if(!this.id || this.realPhone) return
            this.realPhone = '正在获取...'
            this.$axios({
                url:'/jbbcs/customer/getMobile',
                method:'get',
                params:{
                    enterpriseId:this.id
                }
            }).then(res=>{
                if(res.data.code == 1){
                    this.realPhone = res.data.content
                }else{
                    this.realPhone = ''
                }
            }).catch(err=>{
                this.realPhone = ''
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.phoneCard{
    white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/common/common/phoneCard.vue